import { useQuery } from "@tanstack/react-query";

import type { SkillCollectionRecord } from "./types";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

interface GetSkillCollectionResponse {
  success: boolean;
  skill_collection: SkillCollectionRecord;
}

export const useGetSkillCollection = (workspaceId: number | null, collectionId: string | null) => {
  const auth = useAuth();
  const userToken = auth?.userToken ?? "";

  return useQuery({
    queryKey: ["skill-collection", workspaceId, collectionId],
    queryFn: async (): Promise<GetSkillCollectionResponse> => {
      if (!workspaceId || !collectionId) {
        throw new Error("Missing workspace or collection ID");
      }
      const res = await fetch(ENDPOINTS.skill_collections.get(workspaceId, collectionId), {
        headers: jsonAuthHeaders(userToken),
      });
      return handleResponse(res);
    },
    enabled: !!workspaceId && !!collectionId && !!userToken,
  });
};
